export default "__VITE_ASSET__BVaGzGJ5__"